import { Pipe, PipeTransform } from '@angular/core';
import type { ShColumn } from '../table.models';

/**
 * The value of a column for a row: `column.value(row)`, else `row[key]`. Pure,
 * so a cell is only re-evaluated when its row or column changes (see the
 * freeze trap on `ShTableComponent`).
 */
@Pipe({ name: 'shCellValue', standalone: true, pure: true })
export class ShCellValuePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(row: unknown, column: ShColumn<any>): any {
    if (column.value) return column.value(row);
    return row === null || row === undefined
      ? undefined
      : (row as Record<string, unknown>)[column.key];
  }
}
